import React from 'react';
import { Typography as PdcTypography } from '@mzc-pdc/ui';
import { TypographyProps } from './infrastructures/TypographyProps';

export const H6 = (props: TypographyProps) => (
  <PdcTypography variant={'h6'} component={'h6'} align={props.centered ? 'center' : undefined}>
    {props.children}
  </PdcTypography>
);
